import { render } from "./ui-uploadfilebox.vue?vue&type=template&id=d77ac546"
import script from "./ui-uploadfilebox.vue?vue&type=script&lang=js"
export * from "./ui-uploadfilebox.vue?vue&type=script&lang=js"

import exportComponent from "/home/source/apps.macrofox.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__